<form [formGroup]="form">
  <app-guide-card [fullWidth]="fullWidth" [valid]="form.get('detailCharacteristics.fromGridAreaId')?.valid && form.get('detailCharacteristics.toGridAreaId')?.valid">
    <div title>
      {{ 'meteringPoint.create.exchange.title' | translate }}
    </div>
    <div description>
      {{ 'meteringPoint.create.exchange.description' | translate }}
    </div>
    <div>
      <fieldset formGroupName="detailCharacteristics">
        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.fromArea' | translate }}</label>
          <select appSelect [collection]="completeGridAreaList" [numericValues]="true" formControlName="fromGridAreaId"></select>
        </app-input-group>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.toGrid' | translate }}</label>
          <select appSelect [collection]="completeGridAreaList" [numericValues]="true" formControlName="toGridAreaId"></select>
        </app-input-group>
      </fieldset>
    </div>
  </app-guide-card>
</form>
